
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import { f as PendoLoading } from './pendo-loading-mixin.js';
import numeral from 'numeral';

var script = {
  name: 'PendoMetric',
  components: {
    PendoIcon
  },
  directives: {
    PendoLoading
  },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    value: {
      type: [Number, String],
      default: null
    },
    format: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    trending: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: '#2a2c35'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedValue() {
      return this.format ? numeral(this.value).format(this.format) : this.value;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: "pendo-metric pendo-metric--" + _vm.type
  }, [_c('div', {
    staticClass: "pendo-metric__container"
  }, [_c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading",
      value: {
        loading: _vm.loading,
        skeletonProps: {
          height: 24
        }
      },
      expression: "{\n                loading,\n                skeletonProps: { height: 24 },\n            }"
    }],
    staticClass: "pendo-metric__value",
    style: {
      color: _vm.color
    }
  }, [_vm._t("value", [_vm._v("\n                " + _vm._s(_vm.formattedValue) + "\n            ")], {
    "formattedValue": _vm.formattedValue
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pendo-metric__label"
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), _vm.trending && _vm.type !== 'secondary' ? _c('div', {
    staticClass: "pendo-metric__trending"
  }, [_c('pendo-icon', {
    attrs: {
      "type": "arrow-" + _vm.trending,
      "stroke": _vm.trending === 'up' ? '#00C583' : '#CC3340',
      "size": "18"
    }
  })], 1) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-metric.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoMetric = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoMetric;
